var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckplusVLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.551,
    height: 42.406,
    viewBox: "0 0 60.551 42.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-89.169 -72.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset_2",
    "data-name": "Asset 2",
    transform: "translate(89.169 72.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M20.693,42.145a.862.862,0,0,1-1.224,0L.249,22.943a.862.862,0,0,1,0-1.224L21.719.249a.862.862,0,0,1,1.224,0l19.2,19.2a.862.862,0,0,1,0,1.224L38.8,23.986a.862.862,0,0,1-1.224,0L22.917,9.328a.862.862,0,0,0-1.224,0L9.328,21.719a.862.862,0,0,0,0,1.224L23.986,37.6a.862.862,0,0,1,0,1.224Z",
    transform: "translate(0.006 0.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M41.7,42.146a.862.862,0,0,1-1.224,0L21.3,22.944a.862.862,0,0,1,0-1.224l3.32-3.32a.862.862,0,0,1,1.224,0L40.5,33.058a.862.862,0,0,0,1.224,0l12.39-12.364a.862.862,0,0,0,0-1.216L39.458,4.82a.862.862,0,0,1,0-1.216L42.777.25a.862.862,0,0,1,1.216,0l19.2,19.2a.862.862,0,0,1,0,1.216Z",
    transform: "translate(-2.894 0.005)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckplusVLogo);
export default __webpack_public_path__ + "static/media/checkplus-v-logo.2d41d103dcafa9fca8039d01e10a258e.svg";
export { ForwardRef as ReactComponent };